module.exports = "/assets/42dba4e5b62aff0be17367421c637050.png";